import axios from "../../../context/axiosConfig";

const pozyczkiUpdateData = async ({ loan, borrower, user }) => {
	return axios.post("/pozyczki/update/data", {
		loan,
		borrower,
		user,
	});
};

export default pozyczkiUpdateData;
